import styled from "styled-components";
import { label, background, text, reference } from "@carvana/helios-styles";
import { useFlags } from "launchdarkly-react-client-sdk";

const Avatar = ({ letter = "", onClick = () => {} }) => {
  const { auctionTheme } = useFlags();
  return (
    <BackgroundCircle
      data-qa="avatar"
      onClick={onClick}
      $isAdesaTheme={auctionTheme === "Adesa"}
    >
      {letter}
    </BackgroundCircle>
  );
};

const BackgroundCircle = styled.button<{ $isAdesaTheme: boolean }>`
  ${label.sm};
  background: ${({ $isAdesaTheme }) =>
    $isAdesaTheme ? background.informational : reference.yellow[400]};
  color: ${({ $isAdesaTheme }) =>
    $isAdesaTheme ? text.inverse : reference.blue[700]};
  text-transform: uppercase;
  border: none;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  cursor: pointer;
`;

export default Avatar;
